<template>
  <nav id="navbar">
    <v-app-bar
      elevation="0"
      :color="
        isProduction !== 'true'
          ? 'green'
          : $vuetify.theme.global.name === 'dark'
          ? '#272727'
          : '#F5F5F5'
      "
      height="64"
      :floating="false"
      :density="false ? 'prominent' : undefined"
      :class="
        $vuetify.theme.global.name === 'dark' ? 'text-white' : 'text-black'
      "
    >
      <v-app-bar-nav-icon v-if="showDrawer" @click.stop="drawer = !drawer" />
      <img
        alt="Smart City Booking"
        src="/app-logo.png"
        style="max-height: 50px; width: auto; max-width: 250px"
        :style="!showDrawer && { marginLeft: '16px' }"
      />
      <v-spacer></v-spacer>
      <span v-if="isProduction !== 'true'" class="font-weight-bold"
        >DIES IST EIN TESTSYSTEM</span
      >
      <v-spacer></v-spacer>
      <v-tooltip location="bottom">
        <template v-slot:activator="{ props }">
          <v-btn
            icon
            variant="text"
            v-bind="props"
            class="mr-1"
            @click="darkMode"
          >
            <v-icon>
              {{
                $vuetify.theme.global.name === "dark"
                  ? "mdi-white-balance-sunny"
                  : "mdi-moon-waxing-crescent"
              }}
            </v-icon>
          </v-btn>
        </template>
        <span>Theme wechseln</span>
      </v-tooltip>
      <v-btn v-if="!isLoggedIn" variant="text" @click="redirectToLoginPage"
        >Anmelden</v-btn
      >
      <v-btn
        v-if="!isLoggedIn"
        variant="text"
        style="margin-right: 16px"
        @click="redirectToRegistrationPage"
        >Registrieren</v-btn
      >
      <v-menu v-if="isLoggedIn">
        <template v-slot:activator="{ props }">
          <v-tooltip location="bottom">
            <template v-slot:activator="{ on: tooltip }">
              <v-btn icon variant="text" v-bind="props">
                <v-icon size="25">mdi-account-circle</v-icon>
              </v-btn>
            </template>
            <span>Profil Einstellungen</span>
          </v-tooltip>
        </template>
        <v-list density="compact">
          <v-list-item inactive>
            <v-list-item-title>{{
              user?.firstName ? user.firstName : "User Name"
            }}</v-list-item-title>
          </v-list-item>
          <v-list color="primary">
            <v-list-item
              v-for="(item, i) in filteredProfileItems"
              :key="i"
              :to="{ name: item.link }"
              :prepend-icon="item.icon"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="logout" prepend-icon=" mdi-logout">
              <v-list-item-title>Abmelden</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      floating
      id="nav"
      v-if="this.showDrawer"
    >
      <div class="v-navigation-drawer__content">
        <v-list density="compact" nav class="py-0" rounded style="padding: 8px">
          <v-select
            class="my-2 text-truncate"
            rounded
            density="compact"
            variant="flat"
            prepend-inner-icon="mdi-home-account"
            bg-color="accent"
            v-model="currentTenant"
            :items="tenants"
            item-title="name"
            item-value="id"
            hide-details
          >
            <template v-slot:prepend-item>
              <v-list-item> Mandant auswählen: </v-list-item>
              <v-divider />
            </template>
          </v-select>

          <v-divider></v-divider>
          <div v-for="parentItem in navItems" :key="parentItem.header">
            <v-list-subheader
              v-if="parentItem.header"
              class="pl-3 py-1 text-subtitle-1"
              >{{ parentItem.header }}
            </v-list-subheader>
            <v-list-item
              v-for="item in parentItem.pages"
              :key="item.title"
              link
              class="my-2"
              :to="{ name: item.link }"
              exact
              color="secondary"
              rounded="xl"
              variant="flat"
              :prepend-icon="item.icon"
            >
              <template v-if="false">
                @TODO: Add to instead of href with rout name instead of path
              </template>
              <v-list-item-title
                :href="item.link"
                target="_blank"
                class="font-weight-medium text-subtitle-2"
                >{{ item.title }}</v-list-item-title
              >
            </v-list-item>
            <v-divider class="mt-2 mb-2"></v-divider>
          </div>
        </v-list>
      </div>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { useDisplay } from "vuetify";
import ToastService from "@/services/ToastService";
import ApiAuthService from "@/services/api/ApiAuthService";
import ApiTenantService from "@/services/api/ApiTenantService";
import Matomo from "@/utils/Matomo";

export default {
  data: () => ({
    drawer: false,
    isProduction: process.env.VUE_APP_IS_PRODUCTION,
    isDarkMode: false,
    profileItems: [
      {
        title: "Objektanzeige",
        link: "objektanzeige",
        icon: "mdi-view-dashboard-outline",
      },
      {
        title: "Objektverwaltung",
        link: "dashboard",
        icon: "mdi-shield-crown-outline",
      },
      {
        title: "Einstellungen",
        link: "settings",
        icon: "mdi-cog-outline",
      },
    ],
    items: [
      {
        header: null,
        pages: [
          {
            title: "Mandanten",
            link: "dashboard",
            icon: "mdi-view-dashboard",
            showAlways: true,
          },
        ],
      },
      {
        header: "Buchungsplattform",
        pages: [
          {
            title: "Buchungen",
            link: "bookings",
            icon: "mdi-book-outline",
            interfaceName: "bookings",
            context: "tenant",
          },
          {
            title: "Gutscheine",
            link: "coupons",
            icon: "mdi-ticket-percent-outline",
            interfaceName: "coupons",
            context: "tenant",
          },
          // {
          //   title: "Veranstaltungsorte",
          //   link: "event-locations",
          //   icon: "mdi-home-city",
          //   interfaceName: "locations",
          //   context: "tenant",
          // },
          {
            title: "Räume",
            link: "rooms",
            icon: "mdi-office-building-marker",
            interfaceName: "rooms",
            context: "tenant",
          },
          {
            title: "Ressourcen",
            link: "resources",
            icon: "mdi-hammer-wrench",
            interfaceName: "resources",
            context: "tenant",
          },
          {
            title: "Tickets",
            link: "tickets",
            icon: "mdi-ticket",
            interfaceName: "tickets",
            context: "tenant",
          },
          {
            title: "Veranstaltungen",
            link: "events",
            icon: "mdi-calendar",
            interfaceName: "events",
            context: "tenant",
          },
          {
            title: "Benutzergruppen",
            link: "user-groups",
            icon: "mdi-account-multiple-outline",
            interfaceName: "user-groups",
            context: "tenant",
          },
          {
            title: "Massenimport",
            link: "bulk-import",
            icon: "mdi-import",
            interfaceName: "Massenimport",
            context: "tenant",
          },
        ],
      },
      {
        header: "Mandant",
        pages: [
          {
            title: "Mandant verwalten",
            link: "tenant",
            icon: "mdi-domain",
            interfaceName: "tenants",
            context: "tenant",
          },
          {
            title: "Mandant Benutzer",
            link: "user",
            icon: "mdi-account-group-outline",
            interfaceName: "users",
            context: "tenant",
          },
          {
            title: "Mandant Rollen",
            link: "roles",
            icon: "mdi-account-key-outline",
            interfaceName: "roles",
            context: "tenant",
          },
        ],
      },
      {
        header: "System",
        pages: [
          {
            title: "Instanz verwalten",
            link: "instances",
            icon: "mdi-home-edit-outline",
            interfaceName: "instance",
          },
          {
            title: "Mandanten",
            link: "instance-tenants",
            icon: "mdi-domain",
            interfaceName: "instance",
          },
          {
            title: "Benutzer",
            link: "instance-users",
            icon: "mdi-account-group-outline",
            interfaceName: "instance",
          },
        ],
      },
      {
        header: null,
        pages: [
          {
            title: "Einstellungen",
            link: "settings",
            icon: "mdi-cog-outline",
            interfaceName: "settings",
            showAlways: true,
          },
        ],
      },
    ],
    //currentTenant: "",
    tenants: [],
  }),
  components: {},
  methods: {
    ...mapActions({
      addToast: "toasts/add",
      deleteUser: "user/delete",
      selectTenant: "tenants/select",
    }),
    resetStores() {
      this.$store.dispatch("reset");
    },
    redirectToLoginPage() {
      this.$router.push("/login");
    },
    redirectToRegistrationPage() {
      this.$router.push("/registrieren");
    },
    logout() {
      ApiAuthService.logout()
        .then(() => {
          this.addToast(ToastService.createToast("logout.success", "success"));
          this.resetStores();

          // reset matomo user identity
          Matomo.trackEvent(["resetUserId"]);
          Matomo.trackEvent(["setCustomDimension", 1, ""]);
          window.location.href = "/";
        })
        .catch((err) => console.error(err))
        .finally(() => {
          this.deleteUser();
        });
    },
    darkMode() {
      this.$vuetify.theme.global.name =
        this.$vuetify.theme.global.name === "dark" ? "light" : "dark";

      localStorage.setItem("theme", this.$vuetify.theme.global.name);
    },
    fetchTenants() {
      ApiTenantService.getTenants(true)
        .then((response) => {
          this.tenants = response.data;
          if (!this.currentTenant && this.tenants.length === 1) {
            this.currentTenant = this.tenants[0].id;
          }
        })
        .catch((err) => console.log(err));
    },
  },
  computed: {
    ...mapGetters({
      user: "user/getUser",
      isAuthorized: "user/isAuthorized",
      getCurrentTenant: "tenants/currentTenantId",
      isLoggedIn: "user/isLoggedIn",
      hasAdminAccess: "user/hasAdminAccess",
    }),
    currentTenant: {
      get: function () {
        return this.getCurrentTenant;
      },
      set: function (newValue) {
        this.selectTenant(newValue);
      },
    },
    navItems() {
      // reduce items to only those that are allowed for the current user
      return this.items
        .map((item) => {
          return {
            ...item,
            pages: item.pages.filter((page) => {
              if (page.showAlways) {
                return true;
              }
              return (
                this.isAuthorized(page.interfaceName) &&
                (page.context !== "tenant" || this.getCurrentTenant)
              );
            }),
          };
        })
        .filter((item) => {
          return item.pages.length > 0;
        });
    },
    filteredProfileItems() {
      return this.profileItems.filter((item) => {
        if (!this.hasAdminAccess && item.link === "dashboard") {
          return false;
        }
        return true;
      });
    },
    showDrawer() {
      // show the drawer only for logged in users on admin routes
      return this.isLoggedIn && this.$route.path.startsWith("/admin");
    },
  },
  async mounted() {
    const { mdAndDown } = useDisplay();
    this.drawer = !mdAndDown.value;
    this.fetchTenants();
  },
};
</script>
<style scoped>
.v-theme--dark.v-navigation-drawer {
  background-color: #363636;
}
.v-theme--dark.v-list-item {
  background: #363636;
  color: #fff;
}
.v-list-item-title {
  font-size: 0.8125rem;
  font-weight: 500 !important;
  line-height: 1rem;
}
.v-theme--light.v-btn.v-btn--icon {
  color: rgba(0, 0, 0, 0.54);
}
</style>
